import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export default function LoginPage() {
  const { instance, inProgress } = useMsal();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async () => {
    if (inProgress !== "none" || isLoggingIn) {
      return; // Prevent multiple login attempts
    }

    setIsLoggingIn(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8F9FA] via-white to-[#E6F0F9] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-12 max-w-md w-full">
        <div className="text-center mb-8">
          <div className="w-24 h-24 bg-white rounded-xl flex items-center justify-center shadow-xl p-2 border-t-4 border-[#E4002B] mx-auto mb-6">
            <img 
              src="/images/CVX_Logo_NoTagline_RGB.png" 
              alt="Chevron Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-3xl font-bold text-[#0054A4] mb-2">OT Operations</h1>
          <p className="text-sm text-gray-600">Enterprise Management Platform</p>
          <div className="w-20 h-1 bg-[#E4002B] mt-3 rounded-full mx-auto"></div>
        </div>

        <button
          onClick={handleLogin}
          disabled={inProgress !== "none" || isLoggingIn}
          className="w-full bg-[#0054A4] hover:bg-[#003A73] text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {(inProgress !== "none" || isLoggingIn) ? (
            <>
              <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Signing in...
            </>
          ) : (
            <>
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              Sign in with Microsoft
            </>
          )}
        </button>

        <p className="text-xs text-gray-500 text-center mt-6">
          Internal Use Only
        </p>
      </div>
    </div>
  );
}
